/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var $ = require("../jquery");
var pli = require("../core");
var simpleDialogRegistry = require("../forms/SimpleDialogRegistry");

var CallbackSubscribable = require("./jquery.callbackSubscribable");

var parentBroadcastManager = pli.findComponent("clientBroadcastManager"),
    nextPersistentMessageNumber = 1;


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Class "ClientBroadcastManager"
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-----------------------------------------------
// Create new instance of ClientBroadcastManager (singleton,
// one instance per browser window).
function ClientBroadcastManager(connectionType) {
    if (typeof connectionType !== "function") {
        throw new Error("Expected a `connectionType` function");
    }

    this._connection = null;
    this._connectionType = connectionType;
    this._isConnected = false;
    this._persistentMessages = {};
    this._updatedCallbacks = new $.Callbacks();
    this._updatedSubscribable = new CallbackSubscribable(this._updatedCallbacks);

    this._sendMessages = this._sendMessages.bind(this);
}


//-----------------------------------------------
// Disconnect from parent or dispose of connection and reset to initial state.
ClientBroadcastManager.prototype._dispose = function disposeBroadcastManager() {
    if (parentBroadcastManager &&
            // ensure parent isn't disposing too (if so, don't bother unregistering)
            !(simpleDialogRegistry && simpleDialogRegistry._isUnloading)) {
        parentBroadcastManager.offUpdated(this._sendMessages);
    }
    if (this._connection && typeof this._connection._dispose === "function") {
        this._connection._dispose();
        this._connection = null;
    }
    this._isConnected = false;
    this._persistentMessages = null;
    this._updatedSubscribable = null;
};


//-----------------------------------------------
// Fires callbacks for each of the messages.
// Expects the raw message(s) to be sent
ClientBroadcastManager.prototype._sendMessages = function sendMessages(raw) {
    if (!raw) { return; } // no messages defined (ignore)

    var i, length, messages, message;
    messages = Array.isArray(raw) ? raw : [raw];
    for (i = 0, length = messages.length; i < length; i += 1) { // Loop through and trigger each received message individually
        message = messages[i];
        this._updatedCallbacks.fire(message);
        // store persistent messages (to send to new connections)
        if (message.id) {
            // add messageNumber to message to allow recovery of order for new connections
            message.messageNumber = nextPersistentMessageNumber;
            nextPersistentMessageNumber += 1;
            this._persistentMessages[message.type + "+" + message.id] = message;
        }
    }
};


//-----------------------------------------------
// Gets all of the persistent messages in the same order as they were sent
// from the server.  This requires that the messages be sorted by their
// messageNumber property to put them back into the correct order.
ClientBroadcastManager.prototype._getPersistentMessages = function getPersistentMessages() {
    var messages,
        messageId;

    if (parentBroadcastManager) {
        return parentBroadcastManager._getPersistentMessages();
    }

    messages = [];

    for (messageId in this._persistentMessages) {
        if (this._persistentMessages.hasOwnProperty(messageId)) {
            messages.push(this._persistentMessages[messageId]);
        }
    }

    messages.sort(function (left, right) {
        return left.messageNumber - right.messageNumber;
    });

    return messages;
};


//-----------------------------------------------
// Ensures a connection to the server.  Will connect to the parent client broadcast
// manager instance if available otherwise starts up the connection to the server.
ClientBroadcastManager.prototype._ensureConnectionToServer = function ensureConnectionToServer() {
    if (!this._isConnected) {
        if (parentBroadcastManager) {
            parentBroadcastManager.onUpdated(this._sendMessages);
            this._isConnected = true;
        } else {
            var config = (pli.config && pli.config.clientBroadcastManager) || {};
            this._connection = new this._connectionType(config, this._sendMessages);
            this._isConnected = true;
        }

        // if we connected, setup disposal on window close
        if (this._isConnected && global.addEventListener !== undefined) {
            global.addEventListener("unload", this._dispose);
        }
    }
};


//-----------------------------------------------
// Add a callback that is triggered when any message is received
// from the server.  The message format is follows:
// {
//   type: "dataCache",
//   id: "messageId",
//   data: { }
// }
ClientBroadcastManager.prototype.onUpdated = function onUpdatedEvent(callback) {
    // delay server connection until first event handler is added
    this._ensureConnectionToServer();

    this._updatedSubscribable.add(callback);

    // Send persistent messages
    var key, messages = this._getPersistentMessages();
    if (messages) {
        for (key in messages) {
            if (messages.hasOwnProperty(key)) { callback(messages[key]); }
        }
    }
};


//-----------------------------------------------
// Remove an existing callback from updated event.
ClientBroadcastManager.prototype.offUpdated = function offUpdatedEvent(callback) {
    this._updatedSubscribable.remove(callback);
};


// return the singleton client broadcast manager
module.exports = ClientBroadcastManager;




//////////////////
// WEBPACK FOOTER
// ./~/pli/clientbroadcastmanager/clientBroadcastManager.js
// module id = 478
// module chunks = 49